import { PointOfInterest } from "@/__generated__/graphql";
import { useFeatureFlag } from "@/hooks";
import { abyssColors } from "@/theme/colors";
import { Close } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { ReviewStatus } from '../../ReviewStatus';
import { ReviewAction } from '../../ReviewAction';
import { ActionMenu } from '../../ActionMenu';
import { usePoiTemplateFields } from "../../../../hooks/usePoiTemplateFields";

type ReviewStatusProps = {
  onClose: () => void;
  currentPoi: PointOfInterest;
};

export const DialogHeader = ({
  currentPoi,
  onClose,
}: ReviewStatusProps) => {
  const isAITEngineer = useFeatureFlag('ait-engineer');
  const isAPIInspector = useFeatureFlag('api-inspector');

  const { templateOfSelectedPoi } = usePoiTemplateFields({
    data: currentPoi || ({} as PointOfInterest),
  });

  return (
    <Stack direction="row" justifyContent="end" alignItems="center" sx={{ padding: '26px 23px 0 23px' }}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        {currentPoi && (
          <>
            {isAITEngineer && (
              <ReviewStatus
                pointOfInterest={currentPoi}
                templateOfSelectedPoi={templateOfSelectedPoi}
              />
            )}
            {isAPIInspector && (
              <ReviewAction
                pointOfInterest={currentPoi}
                templateOfSelectedPoi={templateOfSelectedPoi}
              />
            )}
            <ActionMenu pointOfInterest={currentPoi} />
          </>
        )}
        <IconButton onClick={onClose} size="small">
          <Close sx={{ color: abyssColors.primary[500] }} />
        </IconButton>
      </Stack>
    </Stack>
  )
};